/*
  英语
*/
export default {
  Home: {
    Register: {
      SignIn: 'Sign In',
      SignUp: 'Sign Up',
      IfYouAlreadyHaveAnAccountYouCanLogIn: 'If you already have an account ? You can log in.',
      SignUpForFree: 'Sign Up for Free',
      FullName: 'Full Name',
      EmailID: 'Email Address',
      VerificationCode: 'Verification Code',
      Send: 'Send',
      AVerificationVodeWillBeSentToYourEmail: 'A verification code will be sent to your email',
      TipsOne: 'Please go to your email to check the verification code, it will expire after 60 seconds',
      Password: 'Password',
      ReferralCode: 'Referral Code',
      TipsTwo: "By creating the account, I agree to KakaClo's",
      Terms: 'Terms',
      Conditions: 'Conditions',
      PrivacyPolicy: 'Privacy Policy',
      AndFeesAndCancellation: 'and Fees and Cancellation',
      Closure: 'Closure',
      Submit: 'Submit',
      PasswordCheck1: 'Please enter the password',
      PasswordCheck2: 'Please enter a password of 8 to 20 characters',
      PasswordCheck3: 'Password should include numbers, uppercase and lowercase letters, etc',
      PasswordCheckRule: 'At least one uppercase letter, lowercase letter and number',
      FullNameCheck1: 'Please enter your Full Name',
      FullNameCheck2: 'Please enter a Full Name  of 2 to 255 characters',
      BrandName: 'Brand Name',
      WebsiteURL: 'Website URL',
      Referrer: 'How did you hear about us?',
      PhoneNumber: 'Phone Number',
      Back: 'Back',
      Tips1: 'You already have an account?',
      Tips2: 'Step1: Business Info',
      Tips3: 'Step2: Personal Info',
      Tips4: 'Social Media',
      Tips5: 'Another Brand',
      Tips6: 'A Wholesaler',
      Tips7: 'A KakaClo Employee',
      Tips8: 'Other',
      Tips9: 'By creating the account, I agree to KakaClo’s',
      Tips10: 'Terms & Conditions, ',
      Tips11: 'Privacy Policy',
      Tips12: 'and fees and cancellation'
    },
    Mobile: {
      KakacloYourOneStop: 'Kakaclo, your one-stop',
      ApparelFactoryAndBeyond: 'apparel factory and Beyond',
      TipsOne: 'KakaClo, an apparel platform with its own',
      TipsTwo: 'factory and integrated supply chain, provides',
      TipsThree: 'the most professional dropshipping,',
      TipsFour: 'wholesale and customization service.',
      StartSelling: 'Start Selling',
      SignUpForFree: 'Sign Up for Free',
      MillionsOfProductsAnd: 'Millions of products and',
      ManyMoreAddedEveryDay: 'many more added every day.',
      ViewAll: 'View All',
      YourNewSecretWeaponIn: 'Your New Secret Weapon In The',
      TheFashionBusiness: 'Fashion Business',
      Tips1: 'KakaClo provides the most professional',
      Tips2: 'dropshippingservice with our own factory and',
      Tips3: ' integrated supply chain.',
      SKU: 'SKU',
      IntegratedFactories: 'Integrated Factories',
      CooperatedBrand: 'Cooperated Brand',
      InClassService: 'In-class Service',
      ClothingWholesale: 'Wholesale Clothing',
      Tips5: 'KakaClo is a leading B2B fashion',
      Tips6: 'marketplace that providing the latest in-stock apparel at wholesale price.',
      UpdatingOnADailyBase: 'Updating on a daily base',
      CompetitivePriceWithoutMOQ: 'Competitive Price without MOQ',
      StartNow: 'Start Now',
      Dropshipping: 'Dropshipping',
      Tips7: 'KakaClo Dropshipping helps you to get rid of supplier issues, so that you focus on selling as we manage everything from inventory to delivery.',
      ListingProduct: 'Listing Product',
      Tips8: 'Upload products from KakaClo to',
      Tips9: 'your store with one click',
      ReceivingOrder: 'Receiving Order',
      Tips10: 'Your customer places an order on',
      Tips11: 'your online store',
      CheckingQuality: 'Checking Quality',
      Tips12: 'Strict quality inspection before every',
      Tips13: 'single piece being shipped out.',
      FulfilingPackage: 'Fulfiling Package',
      Tips14: 'Real-time traceable delivery fulfilled',
      Tips15: 'by KakaClo',
      Customization: 'Customization',
      Tips16: 'Take care of every step of the production process, easily make a sample without worring supplier compliance!',
      PrintOnDemand: 'Print on Demand',
      Tips17: 'If you want to print your own logo or design on the product, upload the logo or patterns, we will print for you.',
      PackagingOnDemand: 'Packaging on Demand',
      Tips18: 'Let us know if you have any special packaging requirement, we will pack in the way you want.',
      CustomizeOnDemand: 'Customize on Demand',
      Tips19: 'Share with us your design or idea, we will make a sample for you and keep it as your private style.',
      Tips20: 'who used to run a general store of full categories, now specialized in clothing niche.',
      Thomas: 'Thomas',
      CEOFounder: 'CEO & Founder',
      Tips21: 'A 3rd-party inspection service means a lot to me as a dropshipper. The most reliable way to avoid quality defects',
      Tamara: 'Tamara',
      CEOFounderAtIClosam: 'CEO & Founder at iClosam',
      Tips22: 'quit his bank job and start a Shopify business by work with KakaClo. Hit 1 million at sales last year.',
      Mike: 'Mike',
      CEOFounderAtHalton: 'CEO & Founder at Halton',
      Tips23: 'It not only saved my store from COVID but helping it grow in a way I did not think was possible',
      James: 'James',
      CEOFounderAtNewErie: 'CEO & Founder at New Erie',
      Tips24: 'Diana,a colloges student who has been doing E-commerce business to ease the load of the family.',
      Diana: 'Diana',
      TeArra: 'TeArra',
      Tips25: 'TeArra, a stay-at-home mother who starts her clothing business from a totally new comer at the beginning.',
      FrequentlyAsked: 'Frequently Asked',
      Questions: 'Questions',
      HowLongDoesTheShippingTake: 'How long does the shipping take',
      Tips26: '1、 For US orders that Ship from US warehouse: 3-7 business days',
      Tips27: '2、 For US orders that Ship from China/German warehouse : 7-10 business days',
      Tips28: '3、For Western Europe (Except UK) orders that Ship from German warehouse : 3-7 business days',
      Tips29: '4、 For Western Europe orders that Ship from China/US warehouse: 8-11 business days',
      Tips30: '5, For non-US/non-Western Europe orders: 10-20 business days',
      Tips31: 'What is “Fashion Trend”?',
      Tips32: 'Fashion Trend is a page that presents users with the most participated outfit posts across Instagram. It help our retailers more quickly understand the trend of consumer likes, and the slightest nuance in the industry as it allows users to sort by posting time, the number of likes, and comments.Also, feel free to shop similarly by leveraging our image search tool, find the exact styles you want on KakaClo while saving time.',
      Tips33: 'Does KakaClo Dropshipping require subscription?',
      Tips34: "No, it's completely FREE to use. Unlike other dropshipping services, KakaClo Dropshipping does not charge any transaction fees nor monthly fees. We are on a mission that help entrepreneurs to build an clothing brand that impact the world.",
      Tips35: 'What platforms can I sync KakaClo Dropshipping with?',
      Tips36: 'KakaClo Dropshipping is currently compatible with Shopify, WooCommerce, Shoplazza and Shopline. More stores will be available soon. Stay tuned for updates. KakaClo Dropshipping buyers are permitted to sell on other third-party marketplaces including, but not limited to:',
      Tips37: 'How do I notify customers their order was shipped?',
      Tips38: 'If you would like to provide email updates to your customers when there are updates to their Shopify order, please refer to mailing order status updates. You can set up email notifications and templates from your Shopify Admin page.',
      Tips39: 'Does KakaClo offers custom packaging?',
      Tips40: 'Yes! Just contact your account manager for all the details and we will do custom packaging for you.',
      StartSellingForFree: 'Start Selling for Free',
      GrowYourFashionBusinessWithKakaClo: 'Grow Your Fashion Business with KakaClo',
      WeCareAboutYourDataInOur: 'We care about your data in our',
      PrivacyPolicy: 'privacy policy',
      YourEmail: 'Your Email',
      Login: {
        PhoneNumber: 'Please input your phone number',
        Password: 'Please input password',
        Confirm: 'Confirm',
        LoginFailed: 'Login failed',
        Continue: 'Continue',
        Send: 'Send',
        ResetPasswordUsingEmailAddress: 'Reset password using email address',
        PleaseInputVerificationCode: 'Please input Verification Code',
        PleaseInputNewCode: 'Please input New Password',
        PleaseConfirmPassword: 'Please confirm password',
        PasswordNotice: 'At least one uppercase letter, lowercase letter and number',
        ConfirmPassword: 'The two passwords are inconsistent!',
        Account: 'Don’t have an account?',
        ForgetYourPassword: 'Forget your password?'
      },
      // 首页2.0新增内容
      GetRidOfSupplier: 'Get Rid Of Supplier',
      IssuesWith: 'Issues with ',
      DROPSHIPPING: 'DROPSHIPPING'
    },
    Login: {
      SignIn: 'Sign In',
      EmailID: 'Email ID',
      PhoneNumber: 'Phone Number',
      Password: 'Password',
      RememberMe: 'Remember Me',
      ForgetThePassword: 'Forget the password?',
      FORGETTHEPASSWORD: 'FORGET THE PASSWORD',
      YoullResetYourPasswordByEmail: "You'll reset your password by email",
      VerificationCode: 'Verification Code',
      Send: 'Send',
      Tips1: 'The verification code will be sent to the email you entered, please make sure that your email can receive the email',
      Tips2: 'A Verification code has been sent to your email',
      Tips3: 'seconds later get verification code again',
      Next: 'Next',
      Continue: 'Continue',
      Sure: 'Sure',
      ConfirmPassword: 'Confirm Password',
      HavingTroublePlease: 'Having Trouble? Please',
      ContactUs: 'Contact Us',
      SignUpForFree: 'Sign Up For Free',
      Tips4: 'Create an account, strat your journey with KakaClo, let’s make fashion business easy for you!',
      Tips5: 'If you already have an account ? You can log in.',
      Register: 'Register',
      Tips6: 'A verification code will be sent to your email',
      Tips7: 'Please go to your email to check the verification code, it will expire after 60 seconds',
      Tips8: "By creating the account, I agree to KakaClo's",
      TermsConditions: 'Terms & Conditions',
      PrivacyPolicy: 'Privacy Policy',
      AndFeesAndCancellation: 'and Fees and Cancellation'
    },
    HomeOld: {
      KakaCloYour: 'KakaClo Your',
      OneStop: 'One-Stop',
      Apparel: 'Apparel',
      Factory: 'Factory',
      Tips1: 'KakaClo, an apparel platform with its own factory and integrated supply chain, provides the most professional dropshipping and customization service.',
      EnterYourEmailAdress: 'Enter your email address',
      SignUpForFree: 'Sign Up for Free',
      Tips2: 'Millions of products and many more added every day.',
      ViewAll: 'View All',
      Tips3: 'Your New Secret Weapon in The Fashion Business.',
      Over1000000SKUsAvailable: 'Over 1,000,000 SKUs Available',
      IntegratedWith8600Factories: 'Integrated with 8,600+ Factories',
      UpTo7DaysDelivery: 'Up to 7 Days Delivery',
      TrustedBy11000FashionBrands: 'Trusted by 11,000+ Fashion Brands',
      CompetitivePriceWithoutMOQ: 'Competitive Price without MOQ',
      InClassService: '24/7 In-class Service',
      ClothingWholesale: 'Clothing Wholesale',
      Tips4: 'KakaClo is a leading B2B fashion marketplace that providing the latest in-stock apparel at wholesale price.',
      UpdatingOnADailyBase: 'Updating on a daily base',
      TheSamePriceWholesaleRetailDropshipping: 'The same price：Wholesale, retail, dropshipping',
      StartNow: 'Start Now',
      Dropshipping: 'Dropshipping',
      Tips5: 'KakaClo Dropshipping helps you to get rid of supplier issues, so that you focus on selling as we manage everything from inventory to delivery.',
      HowDoesDropshippingWorkOnKakaClo: 'How Does Dropshipping Work On KakaClo',
      Tips6: 'Upload products from KakaClo to your store with one click',
      Tips7: 'Your customer places an order on your online store',
      Tips8: 'The order goes directly to KakaClo',
      Tips9: 'Real-time traceable delivery fulfilled by KakaClo',
      Customization: 'Customization',
      Tips10: 'Take care of every step of the production process, easily make a sample without worring supplier compliance!',
      PrintOnDemand: 'Print on Demand',
      Tips11: 'If you want to print your own logo or design on the product, upload the logo or patterns, we will print for you.',
      PackagingOnDemand: 'Packaging on Demand',
      Tips12: 'Let us know if you have any special packaging requirement, we will pack in the way you want.',
      CustomizeOnDemand: 'Customize on Demand',
      Tips13: 'Share with us your design or idea, we will make a sample for you and keep it as your private style.',
      HearFromOurKakaClors: 'Hear From Our KakaClors',
      Tips14: 'KakaClo holds its mission to help more and more clothing sellers to grow their businesses from beginning to end',
      PlayTheStory: 'Play the story',
      HowLongDoesTheShippingTake: 'How long does the shipping take',
      Tips15: '1、 For US orders that Ship from US warehouse: 3-7 business days',
      Tips16: '2、 For US orders that Ship from China/German warehouse : 7-10 business days',
      Tips17: '3、For Western Europe (Except UK) orders that Ship from German warehouse : 3-7 business days',
      Tips18: '4、 For Western Europe orders that Ship from China/US warehouse: 8-11 business days',
      Tips19: '5, For non-US/non-Western Europe orders: 10-20 business days',
      WhatIsFashionTrend: 'What is “Fashion Trends”?',
      Tips20: 'Fashion Trend is a page that presents users with the most participated outfit posts across Instagram. It help our retailers more quickly understand the trend of consumer likes, and the slightest nuance in the industry as it allows users to sort by posting time, the number of likes, and comments.Also, feel free to shop similarly by leveraging our image search tool, find the exact styles you want on KakaClo while saving time.',
      Tips21: 'Does KakaClo Dropshipping require subscription?',
      Tips22: "No, it's completely FREE to use. Unlike other dropshipping services, KakaClo Dropshipping does not charge any transaction fees nor monthly fees. We are on a mission that help entrepreneurs to build an clothing brand that impact the world.",
      Tips23: 'What platforms can I sync KakaClo Dropshipping with?',
      Tips24: 'KakaClo Dropshipping is currently compatible with Shopify, WooCommerce, Shoplazza and Shopline. More stores will be available soon. Stay tuned for updates. KakaClo Dropshipping buyers are permitted to sell on other third-party marketplaces including, but not limited to:',
      Tips25: 'How do I notify customers their order was shipped?',
      Tips26: 'If you would like to provide email updates to your customers when there are updates to their Shopify order, please refer to mailing order status updates.',
      Tips27: 'You can set up email notifications and templates from your Shopify Admin page.',
      Tips28: 'Does KakaClo offers custom packaging?',
      Tips29: 'Yes! Just contact your account manager for all the details and we will do custom packaging for you.'
    },
    Home: {
      Tips1: 'Get Rid Of Supplier Issues With',
      Tips2: 'KakaClo DROPSHIPPING',
      StartSelling: 'Start Selling',
      SignUpForFree: 'Sign Up for Free',
      ViewAll: 'View All',
      Tips3: 'Your New Secret Weapon In The Fashion Business',
      Tips4: 'KakaClo provides the most professional dropshipping service with our own factory and integrated supply chain.',
      Tips5: 'service with its own factory and integrated supply chain.',
      IntegratedFactories: 'Integrated Factories',
      CooperatedBrand: 'Cooperated Brand',
      InClassService: 'In-class Service',
      ClothingWholesale: 'Clothing Wholesale',
      Tips6: 'KakaClo is a leading B2B fashion marketplace that',
      Tips7: 'providing the latest in-stock apparel at wholesale',
      price: 'price.',
      UpdatingOnADailyBase: 'Updating on a daily base',
      CompetitivePriceWithoutMOQ: 'Competitive Price without MOQ',
      StartNow: 'Start Now',
      Dropshipping: 'Dropshipping',
      Tips8: 'KakaClo Dropshipping helps you to get rid of supplier issues,',
      Tips9: 'so that you focus on selling as we manage everything from',
      Tips10: 'inventory to delivery.',
      ListingProduct: 'Listing Product',
      Tips11: 'Upload products from KakaClo',
      Tips12: 'to your store with one click',
      ReceivingOrder: 'Receiving Order',
      Tips13: 'Your customer places an order',
      Tips14: 'on your online store',
      CheckingQuality: 'Checking Quality',
      Tips15: 'Strict quality inspection before',
      Tips16: 'every single piece being',
      Tips17: 'shipped out.',
      FulfilingPackage: 'Fulfiling Package',
      Tips18: 'Real-time traceable delivery',
      Tips19: 'fulfilled by KakaClo',
      Customization: 'Customization',
      Tips20: 'Take care of every step of the production process, easily',
      Tips21: 'make a sample without worring supplier compliance!',
      PrintOnDemand: 'Print on Demand',
      Tips22: 'If you want to print your own logo or design',
      Tips23: 'on the product, upload the logo or patterns,',
      Tips24: 'we will print for you.',
      PackagingOnDemand: 'Packaging on Demand',
      Tips25: 'Let us know if you have any special',
      Tips26: 'packaging requirement, we will pack in the',
      Tips27: 'way you want.',
      CustomizeOnDemand: 'Customize on Demand',
      Tips28: 'Share with us your design or idea, we will',
      Tips29: 'make a sample for you and keep it as your',
      Tips30: 'private style.',
      FrequentlyAsked: 'Frequently Asked',
      Questions: 'Questions',
      Tips31: 'KakaClo, an apparel platform with its own',
      Tips32: 'factory and integrated supply chain, provides',
      Tips33: 'the most professional dropshipping and',
      Tips34: 'customization service.',
      HowLongDoesTheShippingTake: 'How long does the shipping take',
      HowLongDoesTheShippingTake1: 'What is KakaClo?',
      HowLongDoesTheShippingTake2: 'KakaClo is an online B2B fashion marketplace of flexible apparel supply chain solutions including clothing wholesale, dropshipping, and customization services.',
      Tips35: '1. For US orders that Ship from US warehouse: 3-7 business days;',
      Tips36: '2. For US orders that Ship from China/German warehouse: 7-10 business days;',
      Tips37: '3. For Western Europe (Except UK) orders that Ship from German warehouse: 3-7 business days;',
      Tips38: '4. For Western Europe orders that Ship from China/US warehouse: 8-11 business days;',
      Tips39: '5. For non-US/non-Western Europe orders: 10-20 business days.',
      WhatIsFashionTrend: 'What is “Fashion Trends”?',
      WhatIsFashionTrend1: 'Is there any monthly fee charged on KakaClo?',
      WhatIsFashionTrend2: 'KakaClo is free to use, no transaction fees or monthly fees are to be charged. You only need to afford the product and shipping costs whether wholesale or dropshipping.',
      Tips40: 'Fashion Trend is a page that presents users with the most participated outfit posts across Instagram. It helps our retailers more quickly understand the trend of consumer likes, and the slightest nuance in the industry as it allows users to sort by posting time, the number of likes, and comments.',
      Tips41: 'Also, feel free to shop similarly by leveraging our image search tool, find the exact styles you want on KakaClo while saving time.',
      Tips42: 'Does KakaClo Dropshipping require subscription?',
      Minimum1: 'Is there any minimum order quantity required for wholesale?',
      Minimum2: 'No, KakaClo offers open packs with no MOQ, you can buy mixed products at wholesale price, even one piece.',
      Tips43: "No, it's completely FREE to use. Unlike other dropshipping services, KakaClo Dropshipping does not charge any transaction fees nor monthly fees. We are on a mission that help entrepreneurs to build an clothing brand that impact the world.",
      SyncProducts1: 'Can I sync products from KakaClo to my online store directly?',
      SyncProducts2: 'Yes, KakaClo is compatible with Shopify, WooCommerce, Shoplazza, and Shopline. More e-commerce platforms will be integrated soon, please stay tuned!',
      Tips44: 'What platforms can I sync KakaClo Dropshipping with?',
      Tips45: 'KakaClo Dropshipping is currently compatible with Shopify, WooCommerce, Shoplazza and Shopline. More stores will be available soon. Stay tuned for updates. KakaClo',
      Tips46: 'Dropshipping buyers are permitted to sell on other third-party marketplaces including, but not limited to:',
      Tips47: 'How do I notify customers their order was shipped?',
      SellOrFrom1: 'Where do you sell to and ship from?',
      SellOrFrom2: 'KakaClo distributes globally, mainly selling to the USA and European countries.',
      SellOrFrom3: 'Most orders are shipped from China, and parts are shipped from USA locally, you can shop products in USA warehouse if you require a USA local delivery.',
      Tips48: 'If you would like to provide email updates to your customers when there are updates to their Shopify order, please refer to mailing order status updates.',
      Tips49: 'You can set up email notifications and templates from your Shopify Admin page.',
      Tips50: 'Does KakaClo offers custom packaging?',
      CustomizationService1: 'Does KakaClo offer customization service for small orders?',
      CustomizationService2: 'Yes, KakaClo accepts custom small orders, including printing, design, packaging, hang tag, and thank cards.',
      CustomizationService3: 'Just contact our customer service team with your custom requirements for all the details.',
      Tips51: 'Yes! Just contact your account manager for all the details and we will do custom packaging for you.',
      StartSellingForFree: 'Start Selling for Free',
      Tips52: 'Grow Your Fashion Business with KakaClo',
      Tips53: 'We care about your data in our',
      Tips54: 'privacy policy',
      EnterYourEmailAdress: 'Enter your email address',
      EnterYourEmail: 'Enter your email',
      BestSellers: 'Best Sellers',
      BestSellersSubject: 'Bestselling products in the clothing wholesale market in the past 30 days',
      ShopNow: 'Shop Now',
      // 新增多语言内容
      FrequentlyAskedQuestions: 'Frequently Asked Questions',
      VerifiedSuppliers: 'Verified suppliers and strict QC',
      SpecializingIn: 'Specializing in clothing for over 15 years',
      NoFulfillment: 'No fulfillment worries',
      DailyUpdate: 'Daily update 1,000+ items',
      StablyCooperated: 'Stably cooperated with high- quality suppliers, KakaClo has the BEST cost performance under same quality.',
      Quality: 'Quality',
      StrictQC: 'Strict QC',
      EverySingle: 'Every single product will go through our rigorous quality inspection before we send it to your customers',
      Prices: 'Prices',
      StartFrom: 'Start from $1.99',
      StablyCooperatedWith: 'Stably cooperated with high- quality suppliers, KakaClo has better cost performance under same quality',
      Styles: 'Styles',
      AllCategories: 'All categories are available on KakaClo, including Women, Men, Kids, Maternity clothes, accessories etc',
      OnTrend: 'On-trend',
      DailyUpdate1000: 'Daily update 1,000+',
      MoreThan1000: 'More than 1000 on-trend items updated weekly for you to add to your store. Catch up with the latest fashion on KakaClo',
      Tops: 'Tops',
      Blouses: 'Blouses',
      Dress: 'Dress',
      Jumpsuit: 'Jumpsuit',
      Lingerie: 'Lingerie',
      Denim: 'Denim',
      Sport: 'Sport',
      Pajamas: 'Pajamas',
      ClothingWithCooperated: 'Clothing with Cooperated Factories',
      TrustedByFashion: 'Trusted By Fashion Brands',
      RequireFor: 'Require For Mass Products',
      OfferInClass: 'Offer In Class Service',
      PlayVideo: 'Play Video'
    },
    Evaluate: {
      Tips1: 'Who used to run a general store of full categories, now specialized in clothing niche.',
      Thomas: 'Thomas',
      CEOFounder: 'CEO & Founder',
      Tips2: 'A 3rd-party inspection service means a lot to me as a dropshipper. The most reliable way to avoid quality defects',
      Tamara: 'Tamara',
      CEOFounderAtIClosam: 'CEO & Founder at iClosam',
      Tips3: 'Quit his bank job and start a Shopify business by work with KakaClo. Hit 1 million at sales last year.',
      Mike: 'Mike',
      CEOFounderAtHalton: 'CEO & Founder at Halton',
      Tips4: 'It not only saved my store from COVID but helping it grow in a way I did not think was possible',
      James: 'James',
      CEOFounderAtNewErie: 'CEO & Founder at New Erie',
      Tips5: 'Diana,a colloges student who has been doing E-commerce business to ease the load of the family.',
      Diana: 'Diana',
      Tips6: 'TeArra, a stay-at-home mother who starts her clothing business from a totally new comer at the beginning.',
      TeArra: 'TeArra'
    },
    Dropshipping: {
      Dropshipping: 'Dropshipping',
      Apparel: 'Apparel',
      DropshippingHas: 'Dropshipping Has',
      NeverBeenSoEasy: 'Never Been So Easy',
      Tips1: 'Find the best dropshipping products from verified suppliers.',
      CompletelyFree: 'Completely Free.',
      StartSelling: 'Start Selling',
      SignUpForFree: 'Sign Up For Free',
      Tips2: 'KakaClo Quality Control Center Provides',
      Tips3: 'Customers With The Best Quality',
      Tips4: 'KakaClo applies strict quality inspection to every single piece before shipping them out, thus you can rest assured with your customer satisfaction regarding the quality of products.',
      Tips5: 'Why Choose KakaClo To Dropship Clothes',
      Tips6: 'KakaClo, the industry-leading apparel supply chain platform, provides Dropshipping Service for products available in stock in European and American warehouses.',
      Tips7: 'Professional R&D team and Its own apparel factory',
      Tips8: 'KakaClo provides the customers with latest unique on-trend items with super competitive prices',
      Tips9: 'Independent quality inspection center',
      Tips10: 'Unlike other dropshipping suppliers, KakaClo does strict quality inspection itself before every single piece being shipped out',
      Tips11: 'Global logistics and warehousing system',
      Tips12: 'Ensures fast and effective order processing and delivery and now has warehouses in Europe America and China',
      Tips13: 'User friendly integration solutions',
      Tips14: 'KakaClo users can easily add their own stores to KakaClo platform and upload products with only a few clicks',
      Tips15: 'Ecommerce Platform Integrations Available',
      Tips16: 'How Does Dropshipping Work On KakaClo',
      ListingProduct: 'Listing Product',
      Tips17: 'Upload products from KakaClo to your store with one click',
      ReceivingOrder: 'Receiving Order',
      Tips18: 'Your customer places an order on your online store',
      CheckingQuality: 'Checking Quality',
      Tips19: 'Strict quality inspection before every single piece being shipped out.',
      FulfilingPackage: 'Fulfiling Package',
      Tips20: 'Real-time traceable delivery fulfilled by KakaClo',
      StartNow: 'Start Now',
      ApparelDropshippingHas: 'Apparel Dropshipping Has',
      Tips21: 'Find the best dropshipping products from verified suppliers. Completely Free.',
      Tips22: 'KakaClo Quality Control Center Provides Customers With The Best Quality',
      Tips23: 'KakaClo applies strict quality inspection to every single piece before shipping them out, thus you can rest assured with your customer satisfaction regarding the quality of products.',
      Tips24: 'Why Choose KakaClo To Dropshipping Clothes',
      Tips25: 'KakaClo, the industry-leading apparel supply chain platform, provides Dropshipping Service for products available in stock in European and American warehouses.',
      Tips26: 'Professional R&D team and Its own apparel factory',
      Tips27: 'KakaClo provides the customers with latest unique on-trend items with super competitive prices',
      Tips28: 'Independent quality inspection center',
      Tips29: 'Unlike other dropshipping suppliers, KakaClo does strict quality inspection itself before every single piece being shipped out',
      Tips30: 'Global logistics and warehousing system',
      Tips31: 'Ensures fast and effective order processing and delivery and now has warehouses in Europe America and China',
      Tips32: 'User friendly integration solutions',
      Tips33: 'KakaClo users can easily add their own stores to KakaClo platform and upload products with only a few clicks',
      Tips34: 'Ecommerce Platform Integrations Available',
      Tips35: 'How Does Dropshipping Work On KakaClo',
      Tips36: 'Upload products from KakaClo to your store with one click',
      Tips37: 'Your customer places an order on your online store',
      Tips38: 'Strict quality inspection before every single piece being shipped out.',
      Tips39: 'Real-time traceable delivery fulfilled by KakaClo',
      Tips40: 'who used to run a general store of full categories, now specialized in clothing niche.',
      Thomas: 'Thomas',
      CEOFounder: 'CEO & Founder',
      Tips41: 'A 3rd-party inspection service means a lot to me as a dropshipper. The most reliable way to avoid quality defects',
      Tamara: 'Tamara',
      CEOFounderAtIClosam: 'CEO & Founder at iClosam',
      Tips42: 'quit his bank job and start a Shopify business by work with KakaClo. Hit 1 million at sales last year.',
      Mike: 'Mike',
      CEOFounderAtHalton: 'CEO & Founder at Halton',
      Tips43: 'It not only saved my store from COVID but helping it grow in a way I did not think was possible',
      James: 'James',
      CEOFounderAtNewErie: 'CEO & Founder at New Erie',
      Tips44: 'Diana,a colloges student who has been doing E-commerce business to ease the load of the family.',
      Diana: 'Diana',
      Tips45: 'TeArra, a stay-at-home mother who starts her clothing business from a totally new comer at the beginning.',
      TeArra: 'TeArra'
    },
    CustomizationNew: {
      POWERFORTHENEXTMAKERS: 'POWER FOR THE NEXT MAKERS',
      OFFASHION: 'OF FASHION',
      INeedCustomization: 'I Need Customization',
      YouVeGotThevision: 'You’ve got the vision',
      WeVeGotTheTools: 'We’ve got the tools',
      Tips1: 'KakaClo Studio stitches an ecosystem of software and',
      Tips2: 'services that enables fashion designers and enterprises to',
      Tips3: 'work with real time 3D simulation, surpassing their',
      Tips4: 'productivity, sustainability and creativity.',
      AgileProduction: 'Agile Production',
      Tips5: 'The first mass production, the fastest delivery in 14 days',
      Tips6: 'Return orders for mass production and delivery within 5 days',
      FastDelivery: 'Fast Delivery',
      KakaClothingStudio: 'Kaka Clothing Studio',
      Tips7: 'The meta fashion workshop(Coming soon)',
      ClothingWith: 'Clothing With',
      CooperatedFactories: 'Cooperated Factories',
      TrustedBy: 'Trusted By',
      FashionBrands: 'Fashion Brands',
      Require: 'Require',
      LowMOQ: 'Low MOQ',
      ForMassProducts: 'For Mass Products',
      Offer: 'Offer',
      InClassService: 'In Class Service',
      Tips8: 'Made With Care And Made To Order',
      Tips9: 'No need for design sketches, use existing pattern modules for combined design.',
      WhatWeProvide: 'What We Provide',
      PrintOnDemand: 'Print on Demand',
      Tips10: 'If you want to print your own logo or design on the product, upload the logo or patterns, we will print for you.',
      PackagingOnDemand: 'Packaging on Demand',
      Tips11: 'Let us know if you have any special packaging requirement, we will pack in the way you want.',
      CustomizeOnDemand: 'Customize on Demand',
      Tips12: 'Share with us your design or idea, we will make a sample for you and keep it as your private style.',
      POWERFORTHE: 'POWER FOR THE',
      NEXTMAKERSOF: 'NEXT MAKERS OF',
      FASHION: 'FASHION',
      Tips13: 'KakaClo Studio stitches an ecosystem of',
      Tips14: 'software and services that enables fashion',
      Tips15: 'designers and enterprises to work with real',
      Tips16: 'time 3D simulation, surpassing their',
      Tips17: 'productivity, sustainability and creativity.',
      Tips18: 'The first mass production, the fastest',
      Tips19: 'delivery in 14 days / Return orders for mass',
      Tips20: 'production and delivery within 5 days',
      CompetitiveAdvantage: 'Competitive Advantage',
      MadeWithCareAnd: 'Made With Care And',
      MadeToOrder: 'Made To Order'
    },
    Customization: {
      CustomClothing: 'Custom Clothing',
      Tips1: 'Enjoy free design elements at your fingertips',
      INeedCustomization: 'I Need Customization',
      ServiceProcess: 'Service Process',
      Tips2: 'Whether you are an overseas apparel brand owner, apparel designer, offline or online apparel seller, KakaClo will be your best partner for custom apparel production.',
      Tips3: 'Submit your custom requirements',
      ClickThe: 'Click the',
      Tips4: 'fill in the information of the products you need to customize.',
      Tips5: 'Get in touch with our customer service representative',
      Tips6: 'Our customer service representative will send you a contact email to communicate your custom requirements with you.',
      Tips7: 'Payment and delivery of samples',
      Tips8: 'The customer pays the proofing fee and Kakaclo will mail the sample to the customer for confirmation.',
      Tips9: 'Confirmation of samples and formal production',
      Tips10: 'Once the sample is confirmed, you can contact our customer service representative to start formal production.',
      OurAdvantages: 'Our Advantages',
      FastResponse: 'Fast Response',
      Tips11: 'Fast response and quick action. Your dedicated account manager will process your requirement on the same day.',
      QuickProofing: 'Quick Proofing',
      Tips12: 'Fast return of your sample. Normally you can get your sample in 1-3 days.',
      MeetDifferentNeeds: 'Meet Different Needs',
      Tips13: 'Strong R&D and product team can meet your customization needs down to the fabric level.',
      LowMOQ: 'Low MOQ',
      Tips14: 'Low MOQ for mass production of your customized products.'
    },
    Banner: {
      Tips1: 'Millions Of Products And Many More Added Every Day',
      Tips2: "Offering Abundant Affordable Women's, Men's, Children's, Holiday Attire, and Accessories Wholesale."

    },
    About: {
      AboutUs: 'About Us',
      Tips1: 'KakaClo is the industry-leading apparel supply chain platform that focuses on providing customers with in stock apparel custom production and dropshipping service.',
      Tips2: "KakaClo is deeply engaged in the apparel supply chain. In addition to its own R&D team and apparel factory, KakaClo also technically empowers apparel fabric factories and tens of thousands of small and medium-sized apparel processing plants, so as to realize the quick returns of small orders in China's apparel industry chain.",
      Tips3: 'KakaClo offers full-process quality inspection and cross-border logistics and warehousing services, provides dropshipping service for products available in stock and custom apparel production service for global clothing sellers.',
      Tips4: 'How Does KakaClo Dropshipping Inspection Center Work?',
      OurBlog: 'Our Blog',
      Tips5: 'Click to view more company blog content',
      ReadMore: 'Read More',
      YouTubeVideoPlayer: 'YouTube video player'
    },
    terms: {
      TermsConditions: {
        TermsConditions: 'Terms & Conditions',
        Tips1: 'These Terms and Conditions (these “Terms”) of KakaClo, including, without limitation, the purchase of a membership subscription to utilize the Services (a “Membership”). These Terms do not apply to any content or services provided by third parties, whether or not such third-party services (or links thereto) appear on KakaClo’s website or are otherwise incorporated into the Services. These Terms affect your rights, so please read them carefully. Subject to these Terms, KakaClo will use commercially reasonable efforts to provide to you the Services and commercially reasonable technical support via KakaClo’s website and/or mobile applications available on various platforms in accordance with KakaClo’s standard practices."',
        Tips2: '1. Acceptance of terms and Conditions',
        Tips3: 'By using the Services, you are expressing your acceptance of and willingness to be legally bound by these Terms, as amended from time to time. Your use of a particular KakaClo webpage included within the KakaClo website may also be subject to additional terms outlined elsewhere on such webpage. You may not use the Services without accepting these Terms. Individuals must be 18 years of age or older to use the Services, or, if under 18, be at least 13 years old and have the consent and active involvement of a parent or legal guardian. If you are agreeing to these Terms on behalf of a legal entity, you represent to KakaClo that you have the authority to bind such entity and its affiliates to these terms. In such, case the term “you” or “your” as used herein will also refer to such entity and its affiliates. Subject to your compliance with these Terms, KakaClo grants you a personal, limited, non-exclusive, non-transferable, non-sublicensable, revocable license to access and use the Services during the term of your Membership.',
        Tips4: '2. Changes to Terms and Conditions',
        Tips5: 'KakaClo may, from time to time and in its sole and absolute discretion, amend or modify these Terms with or without notice to you; provided that KakaClo will use commercially reasonable efforts to give you at least 14 days’ prior notice on KakaClo’s website or via email of any such amendment or modification. The most current version of these Terms will supersede all previous versions, and your use or continued use of the Services will constitute your acceptance of and willingness to be bound by such version of these Terms. The most current version of these Terms may be viewed at any time by clicking on the “Terms of Use” link at the bottom of KakaClo’s website.',
        Tips6: '3. Your Information and Content',
        Tips7: 'As part of the Membership registration process (including free trials, as described below), you will be required to provide certain personal identifying and financial information in connection with your KakaClo account. You may also add additional personal information to your account profile at your discretion (such information is not required to use the Services but may improve the user experience). All information you provide to KakaClo, directly or indirectly, is subject to KakaClo’s Privacy Policy, which policy you agree to by your use of the Services, so please review it carefully to understand KakaClo’s privacy practices.',
        Tips8: "Subject to KakaClo's Privacy Policy, KakaClo is free to use any comments, information, ideas, concepts, reviews, and/or techniques provided by you to KakaClo or its affiliates (e.g., via communications or questionnaires directly with KakaClo or post or comments made on KakaClo’s website), directly or indirectly (collectively, “User Content”), without any form of compensation, acknowledgment or payment to you.",
        Tips9: 'Notwithstanding anything to the contrary, KakaClo shall have the right to collect and analyze data and other information relating to the provision, use, and performance of various aspects of the Services and related systems and technologies (including, without limitation, information concerning your User Content and data derived therefrom), and KakaClo will be free (during and after the term hereof) to (a) use such information and data to improve and enhance the Services and for other development, diagnostic and corrective purposes in connection with the Services and other KakaClo offerings, and (b) disclose such data solely in aggregate or another de-identified form in connection with its business. In furtherance of the foregoing, if you provide any suggestions, enhancement requests, recommendations, comments, or other feedback relating to the Services to KakaClo, you agree that KakaClo and its affiliates may freely use, reproduce, license, distribute, and otherwise commercialize the feedback in connection with the Services and/or for any other lawful purpose, on a royalty-free, worldwide, transferable, sublicensable, irrevocable, perpetual basis. KakaClo will not be obligated to implement any feedback or correct any defects, bugs, or errors in the service identified in the feedback or otherwise.',
        Tips10: "In addition to the foregoing, you hereby also grant to KakaClo a nonexclusive, worldwide, transferable, sublicensable (to its subcontractors and service providers), irrevocable, royalty-free, fully paid-up license to access, use, display, reproduce, modify and process your User Content in accordance with these Terms and KakaClo’s Privacy Policy, as each it's amended from time to time.",
        Tips11: '4. GOVERNING LAW',
        Tips12: 'These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of Ireland.'
      },
      ShippingDelivery: {
        ShippingDelivery: 'Shipping &Delivery',
        Tips1: 'Delivery Time: Processing Time+Shipping Time',
        Tips2: "Our estimated delivery dates are based on several factors, including the destination address, the shipping options you've chosen, and how quickly we can assemble and prepare your items for shipment. You can calculate delivery estimates by taking the processing time for your order and adding the delivery time based on the shipping method you've chosen.",
        Tips3: 'We are excited to offer international shipping for most destinations of the world. The super savings option will take 10 to 15 business days and the faster delivery will take 5 to 10 business days with an extra1 to 3 business days of processing time for every order. If you have any further questions, please contact our customer services at info@kakaclo.com.',
        Tips4: 'Please use the chart below to help understand how long it will take to receive your order.',
        Tips5: '(*There is a different processing time for a different item. You can check the processing time from the product page. Once your order is placed, you can check order shipping info from the online order status page. We will also inform you through your registered email.)',
        NoteForTaxes: 'Note for taxes',
        Tips6: 'For most of the countries, our customers do not need to pay for importing fees, duties or VAT(Valued Additional Tax). However, for some limited countries (especially for some European countries such as Germany, Italy, UK and Canada, etc.) may need to pay duties or VAT according to your countries’ levying rules.',
        Tips7: 'We are not responsible for late shipments due to invalid address, customs clearance procedures, inclement weather, holidays, natural disasters or carrier delays.',
        Tips8: 'Please keep in mind holidays do not count as a business day and should be considered when calculating shipping times.',
        Tips9: 'Sometimes unexpected delay is caused due to thorough inspection, out of stock issue, especially during high-volume periods.',
        Tips10: 'In case of any question and unexpected delay you can always contact with our customer service.',
        Tips11: 'If you don’t receive the parcel within this period, please contact us.',
        Tips12: '＊Please contact us within 6 months of shipment if the package does not arrive in time, our support team (info@kakaclo.com) will get back to you within 24 hours. Note that overdue requests may not be accepted.',
        Tips13: 'Note: Affected by Covid-19, there will be some delay on the delivery.',
        Tips14: 'If you have any problem,please contact us',
        Tips15: 'Service Tel: +1 626 866 2112',
        Tips16: 'Email: info@KakaClo.com'
      },
      RefundInformation: {
        Tips1: 'Return and Refund Policy',
        Tips2: 'To create a great trading environment and improve the services of KakaClo, KakaClo hereby issue the general policy to return and refund behavior. This Policy applies to all users on KakaClo.',
        Accept: 'Accept',
        Tips3: 'KakaClo reserves the right to update the rules when necessary, and the updated version will be published on KakaClo with immediate effect. If you refuse to accept the policy, you are deemed to have waived the use of the services provided by KakaClo immediately. All buyers or suppliers are deemed to accept the rules if they are using the services provided by KakaClo.',
        Tips4: 'For after-sales issues, buyers should file a return & refund application within 30 days from the delivery day. ',
        Tips5: 'Once the buyer submits the after-sales application, he/she needs to provide evidence (as the clause said below) to the KakaClo. If the buyer cannot provide compelling evidence in time, the KakaClo have the right to reject the refund or return the application.',
        Tips6: 'All items must be returned in good condition with original box/packaging, including manufacturer tags, parts, and accessories.',
        Tips7: 'Whether the evidence is compelling or not will ultimately be determined by KakaClo.',
        Tips8: 'Under Various Circumstances',
        Tips9: '1. Not shipped after processing time',
        Tips10: 'The buyer has the right to apply for a full refund for the order that was not shipped out beyond the processing time (subject to the estimated processing time displayed on the order page).',
        Tips11: '2. Wrong receipt information',
        Tips12: 'If the buyer fills in the receiving information incorrectly, please contact the customer service or docking personnel in time to confirm whether the goods have been shipped.',
        Tips13: 'If there is no delivery, the buyer can update the delivery address with the correct information.',
        Tips14: 'If the goods have been shipped, the buyer needs to contact the logistics company to redeliver.',
        Tips15: 'If the refund application is approved, the buyer must return the product at his own expense and upload the return tracking information in a timely manner. After KakaClo receives the returned goods without any damage, part of the order amount will be deducted as the cost of repackaging and restocking.',
        Tips16: 'If the goods cannot be redistributed or returned, the buyer shall bear the corresponding losses.',
        Tips17: 'Note: In this case, KakaClo has the right to refuse the refund application.',
        Tips18: '3. Non-Defective Products',
        Tips19: 'If the buyer applies for a return and refund for non-defective products the buyer must send back the product at his/her own expense and upload the return tracking info in time. After the KakaClo receives the returned items without any damage, a portion of the order amount will be deducted as the repacking & restocking fee. Note: the KakaClo has the right to reject the refund application under this circumstance.',
        Tips20: '4. Defective Products (package breakage/significantly not as described/missing or wrong goods/quality problems)',
        Tips21: 'If the buyer detects any problem upon receipt (damaged package/significantly not as described/missing or wrong goods or other quality problems),He / she shall contact KakaClo customer service or handle the receiver within 5 working days from the date of delivery.and provide evidence to prove the problem (pictures of broken products and package outer box with a shipping label on it). The KakaClo may refuse the refund application if the buyer fails to provide compelling evidence in time.',
        Tips22: 'For any problem raised in the process of using the product, Buyers should contact KakaClo for communication within 30 days from the date of shipment,and provide relevant pictures or videos as evidence. If the feedback time is more than 30 days from the delivered time, or the buyer provides insufficient evidence, the KakaClo may refuse the refund application if the buyer fails to provide compelling evidence in time.',
        Tips23: 'If the KakaClo agrees to refund, the buyer shall return the goods in time and upload the tracking number. The KakaClo will refund in full upon receipt.',
        Tips24: 'If the buyer agrees to resend, the buyer shall return and upload the tracking number in time. The KakaClo will reship the product upon receipt. If both parties failed to reach an agreement, the buyer shall contact KakaClo and provide relevant evidence (picture or video of the problem goods). Once the evidence is verified, KakaClo will proactively assist the buyer to get a corresponding refund.',
        Tips25: '5. Logistics issues',
        Tips26: '5.1 Invalid tracking information',
        Tips27: 'If KakaClo verifies that the tracking number is incorrect, the buyer should contact us in time. Check and re-give an accurate tracking number',
        Tips28: '5.2 Untimely tracking info updates',
        Tips29: 'If there is no update of the tracking info for more than 10 business days (from the time in the logistics website tracking info),buyers should contact KakaClo customer service or docking person in time to negotiate a solution.Note: this clause is not applicable for special time/periods such as holidays, covid-19, abnormal weather, or other abnormal situations.',
        Tips30: '5.3 Package not received',
        Tips31: 'If the transit time exceeds the estimated delivery time by 10 days or more and the supplier fails to provide proof of delivery, Buyers should contact KakaClo customer service or docking staff in time',
        Tips32: '6. Others',
        Tips33: 'When encounter holidays, covid-19, abnormal weather, or other abnormal situations, Buyers should contact KakaClo customer service or docking staff in timeto solve the goods or logistic issues.',
        Tips34: 'For any issue received, KakaClo will make a judgment based on the facts. The maximum judging time is two weeks after KakaClo intervened.',
        Tips35: 'For return issues, please contact the corresponding customer service first to match the nearest warehouse.',
        ContactUs: 'Contact Us'
      },
      PrivacyPolicy: {
        PrivacyPolicy: 'Privacy Policy',
        Tips1: "Please take a minute to read the following policy so you understand how we use the personal information we ask you to submit. If you use any of KakaClo's services, you agree to these terms.",
        Tips2: '1. Our commitment to privacy',
        Tips3: 'Your privacy is important to us. To better protect your privacy we provide this notice explaining our online information practices and the choices you can make about the way your information is collected and used. To make this notice easy to find, we make it available from our footer navigation that is found on every page of our website. When you register at KakaClo, we ask you for personal information. We use this information to process your orders, conduct account verifications, and to communicate with you about the status of your orders. We also use your email address to send you newsletters you are subscribed to during registration, as well as messages about KakaClo special offers, promotional announcements and consumer surveys. Occasionally, we send our customers special offers and promotional information via postal mail, using the shipping address provided. If you no longer want to receive the newsletters or other announcements simply unsubscribe by checking the unsubscribe links.',
        Tips4: '2. The information we collect',
        Tips5: 'This notice applies to all information collected or submitted on the KakaClo website. On some pages, you can submit information about other people. For example, if you order a product and want it drop shipped directly to your customer, you will need to submit their address. In this circumstance, the types of personal information collected are:',
        Name: 'Name',
        ShippingAddress: 'Shipping address',
        PhoneNumber: 'Phone number',
        Email: 'Email',
        Tips6: '3. How we use information',
        Tips7: 'The primary use of your personal information, other than directly in connection with a purchase, is to efficiently provide you with personalized, relevant information. We also use registration information to let you know about new features or other offers of interest from us and to address customer service needs and requests.',
        Cookies: 'Cookies',
        Tips8: "Contrary to popular myth, cookies do not extract private or personal information from your computer's memory, but rather, record only information you volunteer to us upon registering or visiting the site. Cookies are tiny files placed onto the hard drive of your computer when you register at our Web site that enable our server to recognize or “remember” who you are each time you return. Cookies can be removed by following Internet browser help file directions.",
        Logfiles: 'Log files',
        Tips9: "Like most standard website servers we use log files. This includes Internet protocol (IP) addresses, browser type, Internet service provider (ISP), referring/exit pages, platform type, date/time stamp, and number of clicks to analyze trends, administer the site, track user's movement in the aggregate, and gather broad demographic information for aggregate use. IP addresses, etc. are not linked to personally identifiable information.",
        Tips10: '4. Our commitment to data security',
        Tips11: "KakaClo takes every precaution to protect our users' information. When users submit sensitive information via the website, their information is protected both online and offline.",
        Tips12: "While we use SSL encryption to protect sensitive information online, we also do everything in our power to protect user-information offline. All of our users' information, not just the sensitive information mentioned above, is restricted in our offices. Only employees who need the information to perform a specific job (for example, our billing clerk or a customer service representative) are granted access to personally identifiable information. Furthermore, ALL employees are kept up-to-date on our security and privacy practices. Finally, the servers that store personally identifiable information are in a secure environment, behind a locked cage in a locked facility.",
        Tips13: 'KakaClo reserves the right to make any amendments, modifications, or changes to this Privacy Policy at any time. If any material change is made to this Privacy Policy, we will notify our users about those changes via email. If you do not agree to such changes, you can modify your notification settings to opt-out of certain notices from KakaClo or its marketing partners. If users have any questions about the security at our website, please contact Customer Support.',
        Tips14: '5. How you can access or correct your information',
        Tips15: 'You can access your personally identifiable information collected by KakaClo by logging into your account and visiting the “Settings” section of the website. You can correct factual errors in your personally identifiable information by sending us a request that credibly shows error. To protect your privacy and security, we will also take reasonable steps to verify your identity before granting access or making corrections.',
        Tips16: '6. How to contact us',
        Tips17: 'Should you have other questions or concerns about these privacy policies, please contact Customer Support.',
        ContactUs: 'Contact Us',
        IPhone: 'IPhone'
      },
      PaymentMethod: {
        PaymentMethod: 'Payment Method',
        Tips1: 'Paying with Credit Card',
        Tips2: '-Choose your items and add them to your shopping cart, select “Credit Card” and click the button “PROCEED TO CHECKOUT”',
        Tips3: '-Complete your shopping by entering your credit card information and clicking the button “PROCEED TO CHECKOUT”',
        Tips4: 'There may be times when your payment method cannot be used, for example, if you select a credit card that is expired.',
        Tips5: 'Paying with PayPal',
        Tips6: '1. With PayPal, you can send payments quickly and securely online.',
        Tips7: '2. Through PayPal, you can pay with a credit card, debit card, or bank account balance.',
        Tips8: "3. Once your order is submitted, you will be redirected to PayPal's site where you can make the payment.",
        Tips9: 'Advantages of using PayPal',
        Tips10: "Payment is traceable. You can trace the status of your payment using your PayPal account. KakaClo doesn't receive your credit card number or bank information (it is safely encrypted through PayPal's server), which limits the risk of unauthorized use.",
        Tips11: 'Paying with Balance',
        Tips12: 'Top up your KakaClo pay balance before using the payment method. You’ll find the “Top-up” button on the “Personal Center” of your backend.',
        Tips13: 'After top up, select “Credit Card” and click the button “PROCEED TO CHECKOUT”.',
        Tips14: 'Make sure there are sufficient funds in your balance.'
      },
      IPRight: {
        IntellectualPropertyRights: 'Intellectual Property Rights'
      },
      ContactUs: {
        ContactInfo: 'Contact Info',
        LosAngeles: 'Los Angeles',
        Tips1: '2580 Corporate Pl F102, Monterey Park,CA',
        NewYork: 'New York',
        Tips2: '418 BROADWAY STE R ALBANY,NY 12207',
        HongKong: 'Hong Kong',
        Tips3: '19H Maxgrand plaza,No.3 Tai Yau Street, San Po Kong, Kowloon, Hong Kong',
        Shenzhen: 'Shenzhen',
        Tips4: '4F No.2 Buliding, TOD technology center, No.7 LiPu Street, Longgang District, Shenzhen City, China',
        DongGuan: 'DongGuan',
        Tips5: '3F B tower, YiAn Industrial Park, No.160 Luyuan road, TangXia Town, DongGuan City, China',
        KakaCloSupport: 'KakaClo Support',
        WathsAppContact: 'WathsApp contact',
        ContactUs: 'Contact Us',
        Email: 'Email',
        Phone: 'Phone',
        YourName: 'Your name',
        Message: 'Message',
        Send: 'send',
        Tips6: 'Please enter your vaild email',
        Tips7: 'Please enter the password',
        Tips8: 'Please enter the message',
        SubmitSuccess: 'Submit Success!'
      },
      AboutUs: {
        AboutUs: 'About Us',
        WelcomeToKakaClo: 'Welcome to KakaClo',
        Tips1: 'KakaClo is an online store. We are committed to providing our customers with A unique, superior and thoughtful online shopping experience. We have high quality manufacturers and suppliers; At the same time, we are constantly optimizing our purchasing and production processes to ensure that our products are of high quality. Please feel free to buy our products on the website.',
        Tips2: "Our website attaches great importance to customer service, and customers' opinions are important information to promote us to develop, improve and enhance ourselves. If you encounter any difficulties during your consumption, please check out other terms of our website or feel free to contact our staff. Contact information can be found in Contact us.",
        Tips3: 'Thank you again for visiting our website and wish you a happy shopping trip!'
      }
    },
    helpCenter: {
      TutorialDetail: {
        Back: 'Back',
        Tutorial: 'Tutorial'
      },
      Tutorial: {
        FAQ: 'FAQ',
        READMORE: 'READ MORE'
      },
      SearchCenter: {
        ShowingAllResultsFor: 'Showing all results for',
        FAQ: 'FAQ',
        Tutorial: 'Tutorial'
      },
      MobileTutorialList: {
        Tutorial: 'Tutorial'
      },
      MobileTutorialDetail: {
        Tutorial: 'Tutorial',
        YouTubeVideoPlayer: 'YouTube video player'
      },
      FAQ: {
        Back: 'Back',
        FAQ: 'FAQ',
        FrequentlyAskedQuestion: 'Frequently Asked Question'
      },
      SearchHead: {
        HELPCENTER: 'HELP CENTER'
      },
      MobileSerachHead: {
        SearchTutorialOrFAQ: 'Search Tutorial or FAQ'
      }
    },
    Customized: {
      AddProduct: {
        BasicInformation: 'Basic Information',
        CustomizeOnDemand: 'Customize on Demand',
        PrintOnDemand: 'Print on Demand',
        ProductName: 'Product Name',
        Services: 'Services',
        CustomPrintedEmbroideredProducts: 'Custom Printed& Embroidered Products',
        Image: 'Image(Image may only be up to 10.)'
      }
    },
    Components: {
      Workstep: {
        Tips1: 'How Does Dropshipping Work On KakaClo',
        Tips2: 'Upload products from KakaClo to your store with one click',
        Tips3: 'Your customer places an order on your online store',
        Tips4: 'The order goes directly to KakaClo',
        Tips5: 'Strict quality check before shipping products out',
        Tips6: 'Real-time traceable delivery fulfilled by KakaClo'
      },
      WhyUsMobile: {
        KakaCloYour: 'KakaClo Your',
        OneStopApparelFactory: 'One-Stop Apparel Factory',
        Tips1: 'KakaClo, an apparel platform with its own factory',
        Tips2: 'and integrated supply chain, provides apparel',
        Tips3: 'wholesale, professional dropshipping and',
        Tips4: 'customization service.',
        WhatWeOffer: 'What We Offer',
        ClothingWholesale: 'Clothing Wholesale',
        StartNow: 'Start Now',
        Tips5: 'KakaClo is the leading apparel marketplace providing the latest in-stock apparel at wholesale price. Millions of apparels are ready to ship without any wholesale MOQ limitation.',
        Dropshipping: 'Dropshipping',
        Tips6: 'KakaClo Dropshipping helps you to get rid of supplier issues, so that you focus on selling as we manage everything from inventory to delivery.',
        Customization: 'Customization',
        Tips7: 'Today is the day to build the apparel business of your dreams. Share your brand with the world — and blow your customers away.',
        HowToBecomeAWholesaler: 'How to become a wholesaler',
        Tips8: '1、No minimum quantity. All products are available from one piece.',
        Tips9: '2、Wholesale, retail, dropshipping are share the same price.',
        HowDoesDropshippingWork: 'How Does Dropshipping Work',
        OnKakaClo: 'On KakaClo',
        Tips10: 'Upload products from KakaClo to your store with one click',
        Tips11: 'Your customer places an order on your online store',
        Tips12: 'The order goes directly to KakaClo',
        Tips13: 'Strict quality check before shipping products out',
        Tips14: 'Real-time traceable delivery fulfilled by KakaClo',
        EcommercePlatform: 'Ecommerce Platform',
        IntegrationsAvailable: 'Integrations Available',
        Tips15: 'Our integration solutions allow you to add products to your stores and sync orders to KakaClo with just a few clicks, saving your time',
        CustomizationService: 'Customization Service',
        PrintOnDemand: 'Print on Demand',
        Tips16: 'We undertake all the processes from',
        Tips17: 'product selection, commodity quality',
        Tips18: 'inspection to delivery, you don’t need to',
        PackagingOnDemand: 'Packaging on Demand',
        Tips19: 'Let us know if you have any special',
        Tips20: 'packaging requirement, we will pack in',
        Tips21: 'the way you want.',
        CustomizeOnDemand: 'Customize on Demand',
        Tips22: 'Share with us your design or idea, we will',
        Tips23: 'make a sample for you and keep it as your',
        Tips24: 'private style.',
        Tips25: 'Your New Secret Weapon in',
        Tips26: 'Clothing Business',
        Tips27: 'More than 1000 on-trend items uploaded weekly for you to add to your store.',
        Tips28: 'No Minimum Order Quantity required per order, one piece is at the wholesale price.',
        Tips29: 'Package takes 5-10 business days to be delivered to the customers.',
        Tips30: 'Dedicated account manager ensures smooth and effective communication during our cooperation.',
        Tips31: 'Every single piece is fully inspected before being shipped out and can be tracked accurately after shipment.',
        Tips32: 'No monthly fee charged, join us and get your business started instantly.',
        VoicesOfTheKakaCloUsers: 'Voices of the KakaClo users',
        DanielFoster: 'Daniel Foster',
        Tips33: 'You know what the right dropshipping company could do for you? Not only making doing online business hands-off, but also giving you 68% increase of your profit, which is amazing and exactly what Kakaclo brought to me, meaning earning me $121k in just 4-months of use.',
        LilyBurrell: 'Lily Burrell',
        Tips34: 'I am not sure if anyone really understands what being a full-time housewife means. I love my 3 beautiful kids and taking care of my family for sure, and I also love that Kakaclo enables me to do a side hustle at the time, through which I earn more than $10K extra money each month with bare efforts.',
        QuentinSwift: 'Quentin Swift',
        Tips35: 'Of course I did my job right, and thanks to my superb partner, Kakaclo who covered all the rest, starting from the scratch, I earned $7768 in under 8 weeks.',
        AboutUs: 'About Us',
        Tips36: 'Kakaclo is a clothing supply chain platform provides dropship service and custom service for all cloth sellers. We are the direct-selling platform gathering professional customization and latest fashion spot goods.',
        Tips37: 'Grow your dropshipping business with KakaClo Join Us now for free',
        Tips38: 'Register For Free'
      },
      ThirdPartyRegistration: {
        FullName: 'Full Name',
        EmailID: 'Email ID',
        Password: 'Password',
        RegisterForFree: 'Register For Free',
        Tips1: 'Please enter the password',
        Tips2: 'Please enter a password of 8 to 20 characters'
      },
      ThirdPartyBind: {
        Tips1: 'Facebook authorized login successfully',
        Tips2: 'Enter your email to bind',
        EmailID: 'Email ID',
        Password: 'Password',
        Bind: 'Bind',
        Tips3: 'Please enter your vaild email',
        Tips4: 'Please enter the password'
      },
      TeamDescription: {
        SupportYouCanGetFromOurTeam: 'Support You Can Get From Our Team',
        ProductDevelopment: 'Product Development',
        Tips1: 'Newest and latest styles on trend in time',
        QualityControl: 'Quality Control',
        Tips2: 'Strict quality inspection for each package before being shipped',
        CustomerService: 'Customer Service',
        Tips3: 'Dedicated account manager from the beginning to the end',
        TechnologyDevelopment: 'Technology Development',
        Tips4: 'To make sure that users have the best shopping experience',
        LogisticWarehouses: 'Logistic & Warehouses',
        Tips5: 'Fastest shipping from global warehouses and digital inventory system to keep every record for your orders',
        Tips6: 'Newest and latest styles on trend in time'
      },
      Services: {
        CustomProduction: 'Custom Production',
        PrintONDemand: 'Print on Demand',
        Tips1: 'If you want to print your own logo or design on the product, upload the logo or patterns, we will print for you.',
        PackagingOnDemand: 'Packaging on Demand',
        Tips2: 'Let us know if you have any special packaging requirement, we will pack in the way you want.',
        CustomizeOnDemand: 'Customize on Demand',
        Tips3: 'Share with us your design or idea, we will make a sample for you and keep it as your private style.'
      },
      RegisterRoute: {
        StartSellingForFree: 'Start Selling for Free',
        Tips1: 'Grow Your Fashion Business with KakaClo',
        StartSelling: 'Start Selling',
        SignUpForFree: 'Sign Up For Free',
        Tips2: 'We care about your data in our',
        Tips3: 'privacy policy',
        EnterYourEmail: 'Enter your email',
        YourEmail: 'Your Email'
      },
      ProductListMobile: {
        SHOPBYCATEGORY: 'SHOP BY CATEGORY',
        BESTSELLERS: 'BEST SELLERS',
        More: 'More',
        NEWARRIVALS: 'NEW ARRIVALS',
        WETHINKYOULLLOVETHESE: "WE THINK YOU'LL LOVE THESE",
        Tips1: 'View more products after registration',
        RegisterForFree: 'Register For Free'
      },
      ProductList: {
        SHOPBYCATEGORY: 'SHOP BY CATEGORY',
        BESTSELLERS: 'BEST SELLERS',
        More: 'More',
        NEWARRIVALS: 'NEW ARRIVALS',
        WETHINKYOULLLOVETHESE: "WE THINK YOU'LL LOVE THESE",
        Tips1: 'View more products after registration',
        RegisterForFree: 'Register For Free'
      },
      Platform: {
        Tips1: 'Ecommerce Platform Integrations Available',
        Tips2: 'Our integration solutions allow you to add products to your stores and sync orders to KakaClo with just a few clicks, saving your time',
        StartForFree: 'Start for Free'
      },
      LoginHead: {
        Back: 'back'
      },
      HomeHead: {
        PersonalCenter: 'Personal Center'
      },
      Head: {
        Home: 'Home',
        Products: 'Products',
        Dropshipping: 'Dropshipping',
        Customization: 'Customization',
        HelpCenter: 'Help Center',
        Company: 'Company',
        AboutUs: 'About Us',
        Blog: 'Blog',
        RegisterForFree: 'Register For Free',
        SignIn: 'Sign In',
        Product: 'Product',
        Order: 'Order',
        LogOut: 'Sign Out'
      },
      Footer: {
        CATEGORIES: 'CATEGORIES',
        Products: 'Products',
        Dropshipping: 'Dropshipping',
        Customization: 'Customization',
        KakaCloAffiliate: 'KakaClo Affiliate',
        RESOURCES: 'RESOURCES',
        PrivacyPolicy: 'Privacy Policy',
        TermsConditions: 'Terms & Conditions',
        ReturnRefund: 'Return & Refund',
        ShippingDelivery: 'Shipping & Delivery',
        PaymentMethod: 'Payment Method',
        ABOUTUS: 'ABOUT US',
        Company: 'Company',
        HelpCenter: 'Help Center',
        ContactUs: 'Contact Us',
        Email: 'Email',
        Phone: 'Phone',
        KakaCloSupport: 'KakaClo Support',
        WathsAppContact: 'WathsApp contact',
        Blog: 'Blog'
      },
      Feedback: {
        Tips1: 'Voices Of The KakaClo Users',
        Tips2: 'You know what the right dropshipping company could do for you? Not only making doing online business hands-off, but also giving you 68% increase of your profit, which is amazing and exactly what Kakaclo brought to me, meaning earning me $121k in just 4-months of use.',
        DanielFoster: 'Daniel Foster',
        Tips3: 'I am not sure if anyone really understands what being a full-time housewife means. I love my 3 beautiful kids and taking care of my family for sure, and I also love that Kakaclo enables me to do a side hustle at the time, through which I earn more than $10K extra money each month with bare efforts.',
        LilyBurrell: 'Lily Burrell',
        Tips4: 'Of course I did my job right, and thanks to my superb partner, Kakaclo who covered all the rest, starting from the scratch, I earned $7768 in under 8 weeks.',
        QuentinSwift: 'Quentin Swift'
      },
      BlackFooter: {
        CATEGORIES: 'CATEGORIES',
        Products: 'Products',
        Dropshipping: 'Dropshipping',
        Customization: 'Customization',
        KakaCloAffiliate: 'KakaClo Affiliate',
        RESOURCES: 'RESOURCES',
        PrivacyPolicy: 'Privacy Policy',
        TermsConditions: 'Terms & Conditions',
        ReturnRefund: 'Return & Refund',
        ShippingDelivery: 'Shipping & Delivery',
        PaymentMethod: 'Payment Method',
        ABOUTUS: 'ABOUT US',
        Company: 'Company',
        Blog: 'Blog',
        HelpCenter: 'Help Center',
        ContactUs: 'Contact Us',
        Email: 'Email',
        Phone: 'Phone',
        KakaCloSupport: 'KakaClo Support',
        WathsAppContact: 'WathsApp contact',
        SiteMap: 'SiteMap',
        ProductAttributes: 'Product Attributes'
      }
    },
    Certification: {
      AddCertification: {
        Back: 'Back',
        ToSignIn: 'To Sign In',
        CompanyInformation: 'Company Information',
        UNVERIFIEDBUYER: 'UNVERIFIED BUYER',
        Tips1: "Please upload your seller's permit to obtain full access. View your state's requirement",
        Tips2: 'here',
        Tips3: 'If you already uploaded a permit on this page, please allow 24 business hours for your account to be reviewed. We will contact you via email. Contact Us below if you have difficulties in uploading below.',
        FirstName: 'First Name',
        LastName: 'Last Name',
        CompanyName: 'Company Name',
        DoYouSellOnline: 'Do you sell online?',
        Yes: 'Yes',
        No: 'No',
        StoreURL: 'Store URL',
        PleaseEnterYourStoreUrl: 'Please enter your store url',
        SellerPermitNumbe: 'Seller Permit Numbe',
        PleaseEnterYourSellerPermitNumber: 'Please enter your seller permit number',
        StorePicture: 'Store Picture',
        Image: 'Image',
        DocumentOFProof: 'Document of Proof',
        DocumentProofOFBusiness: 'Document Proof of Business',
        Tips4: "Please upload seller's permit. Find your state's requirements",
        here: 'here',
        Upload: 'Upload',
        UploadFormat: 'Upload Format',
        CompanyAddress: 'Company Address',
        Address: 'Address',
        City: 'City',
        StateProvince: 'State/Province',
        ZIPPostalCode: 'ZIP/Postal Code',
        Country: 'Country',
        Phone: 'Phone',
        AddCertification: 'Add Certification',
        SubmitLater: 'Submit Later',
        PleaseEnterContent: 'Please enter content',
        Select: 'Select'
      },
      SubmiitedCertification: {
        Back: 'Back',
        AddCertification: 'Add Certification',
        SubmittedSuccessfully: 'Submitted Successfully',
        ThanksForYourSubmission: 'Thanks for your submission.',
        Tips1: 'Our support team will follow up and get back to you as soon as possible.',
        BackToShopping: 'Back'
      }
    },
    BlogContent: {
      Blog: {
        ReadMore: 'Read More'
      },
      Detail: {
        YouTubeVideoPlayer: 'YouTube video player'
      }
    }
  },
  Seas40: {
    Banner: {
      Title1: 'Buy now, Pay later',
      Text1: 'Pay on your terms, when and how you want',
      ApplyNow: 'Apply Now'
    },
    Module1: {
      Title1: 'Flexible Financing',
      Text1: 'Defer payments by up to 90 days, without taking out a loan.',
      Title2: 'Easy Payments',
      Text2: 'Secure, online, local payments for international orders. ',
      Title3: 'Real time updates',
      Text3: 'Full visibility into order status with digital messaging.',
      Title4: 'High credit limit',
      Text4: 'Secure up to $1 Million credit limit.'
    },
    Module2: {
      Title1: 'Say goodbye to advance payments',
      Text1: 'With KakaClo, you now have the power to enjoy a generous up to 90-day payment term on all your purchases. Say goodbye to the pressure of immediate payments and embrace the freedom to manage your finances more effectively.',
      Title2: 'How does it work?',
      Text2: 'Click the "Apply Now" button to submit your information.',
      Text3: 'Tell us about your business.',
      Text4: 'Add your contact details.',
      Text5: 'Enter requested credit amount.',
      Text6: 'Connecting your checking account.',
      Text7: 'Wait for the review result and the approved credit limit.'
    },
    Module3: {
      Title1: 'Requirements',
      Text1: 'You must register with KakaClo before applying.',
      Text2: 'You need to repay the money before the available credit limit can be restored.',
      Text3: 'The order amount must be higher than $2000 to be eligible for use.',
      Text4: 'Orders paid with the 40Seas credit limit do not support refunds after shipment. However, you can return the credit limit before shipment.',
      Title2: 'Frequently Asked Questions',
      Text5: 'How do I apply?',
      Text6: 'First, you need to register on KakaClo. Then, click on the "Apply NOW" button, fill in the information, and submit it. Wait for the review result, which usually takes 3 business days.',
      Text7: 'How much credit limit can I get?',
      Text8: 'The available credit limit varies for each individual. The maximum limit is $1 million, subject to the final approval result.',
      Text9: 'Are there any requirements for using the credit limit for payment?',
      Text10: 'To use the credit limit for payment, the order amount must be higher than $2,000.',
      Text11: 'Can I get a refund for an order paid with the credit limit?',
      Text12: 'Orders can only be canceled and refunded before shipment. Once the order is shipped, cancellation and refund requests cannot be processed. However, for orders paid with credit limit, we do not support partial returns and refunds at any time.',
      Text13: 'How can I restore my credit limit?',
      Text14: 'To restore your credit limit, you must make a repayment first. It may take 1-2 days for the limit to be restored.',
      Text15: 'Are there any fees?',
      Text16: 'There are no fees for the 30-day repayment option. You can choose the repayment period when placing an order.',
      Title3: 'Join the 40Seas community',
      Text17: "Don't wait any longer! Join the 40Seas community today and unlock the freedom of 90-day payment terms. Say yes to seamless shopping and wave goodbye to payment stress.",
      Text18: 'Elevate Your Shopping Experience with KakaClo: Enjoy Flexible Terms on Orders Over $2000.',
      TryNow: 'Try Now'
    }
  },
  AI: {
    Banner: {
      Title1: 'What If Finding Fashion Trends Was No Big Deal?',
      Text1: 'See how Kaka AI software helps fashion brands use data to make accurate plan and forecasts —— without a data scientist',
      Title2: 'Kaka Image Search',
      Text2: 'Reverse Image Search, it helps our retailers more quickly understand the trend of consumer likes, and the slightest nuance in the industry as it allows users to sort by posting time, the number of likes, and comments.',
      Title3: 'Kaka Designer',
      Text3: 'Just upload a reference image,  the AI designer can Generate countless similar and creative images, bringing you more inspiration and innovation.',
      Title4: 'Kaka Overwatch',
      Text4: "Timely access to competitors' new and marketing dynamics, support to view the monitored site's new and hot sales, as well as meta placement and co-reddit.",
      Title5: 'Kaka Model',
      Text5: 'No more expensive mannequin shoots! AI technology allows us to generate real life model images from costume flats and costume dummies! Perfectly reproduced details for a tenth of the price of a real person!',
      Title6: 'Kaka Trend',
      Text6: 'Presents the most participated trends across World.It helps our retailers more quickly understand the trend of consumer likes, and the slightest nuance in the industry as it allows users to sort by posting time, the number of likes, and comments.',
      TryNow: 'Try Now',
      ComingSoon: 'Coming Soon'
    },
    Module: {
      Title1: 'Kaka Image Search',
      Text1: 'It helps our retailers more quickly understand the trend of consumer likes, and the slightest nuance in the industry as it allows users to sort by posting time, the number of likes, and comments.',
      Title2: 'Kaka Model',
      Text2: 'AI technology allows us to generate real life model images from costume flats and costume dummies! Perfectly reproduced details for a tenth of the price of a real person!',
      Title3: 'Kaka Designer',
      Text3: 'Just upload a reference image,  the AI designer can Generate countless similar and creative images, bringing you more inspiration and innovation.',
      Title4: 'Kaka Trend',
      Title5: 'Pop Report',
      Title6: 'Catwalk Trends',
      Text6: 'Description of catwalk trends',
      Title7: 'Color Trends',
      Text7: 'Description of Color Trends',
      Title8: 'Single Product Trend',
      Text8: 'Description of a single product trend',
      Title9: 'Instagram',
      Text9: 'Description of Instagram',
      Title10: 'SHEIN',
      Text10: 'Description of SHEIN',
      Title11: 'FASHIONNOVA',
      Text11: 'Description of FASHIONNOVA',
      Title12: 'Business Report',
      Title13: 'Kaka Overwatch',
      Text13: "Timely access to competitors' new and marketing dynamics, support to view the monitored site's new and hot sales, as well as meta placement and co-reddit.",
      UploadImage: 'Upload Image'
    }
  },
  POD: {
    Module1: {
      Title1: 'Revolutionize Your Style With Personalized Apparel',
      Sub1: 'Discover the power of Print-on-Demand customization at Kakaclo! Create unique, one-of-a-kind clothing that reflects your personality and style.',
      Easytouse: 'Easy to use',
      Unmatchedquality: 'Unmatchedquality',
      Competitivepricing: 'Competitive pricing',
      GetStarted: 'Get Started'
    },
    Module2: {
      Title1: 'You Have Ideas, KakaClo Makes Them A Reality',
      Sub1: 'Whether you’re just getting started or are already running a successful brand, KakaClo is the best partner to help you launch and grow your business.',
      Title2: 'Easy to launch, powerful to use',
      Sub2: 'Set up shop quickly and seamlessly with our easy-to-use interface, and get your products in front of thousands of customers with our robust integrations. Our elite design tools and dedicated customer service team will make running your business a breeze.',
      Title3: 'Unmatched quality for your brand',
      Sub3: 'Deliver consistent, reliable quality for your customers. Don’t just get your first sale, build a brand that fans will keep coming back to.',
      Sub4: '99% of all shipped orders meet our customers’ quality standards. That’s why we’re trusted by the world’s biggest brands to fulfill their products.',
      Title4: 'Competitive pricing',
      Sub5: 'Make money without compromising quality. We offer competitive pricing and the best value for your money.'
    },
    Module3: {
      Title1: 'Work With A Partner, Not Just A Supplier',
      Sub1: 'We fully own our production process and fulfill almost all orders at our in-house facilities in Europe and North America.',
      Title2: 'We take care of:',
      Sub2: 'Quality control',
      Sub3: 'Order fulfillment',
      Sub4: 'Printing tech',
      Title3: 'You get:',
      Sub5: 'Global reach',
      Sub6: 'Repeat customers',
      Sub7: 'Hassle-free profit',
      Sub8: 'Save time and avoid juggling a network of providers.',
      Sub9: 'Choose the simplicity and confidence of working with the most reliable partner.',
      Sub10: 'items shipped since 2023',
      Sub11: 'customer quality satisfaction',
      Sub12: 'items fulfilled every month'
    },
    Module4: {
      Title1: 'Your Partner From First Sale To Global Scale',
      Title2: 'We’ve tried other print-on-demand services, but obviously they didn’t fit us.',
      Sub1: 'The back office for KakaClo is a lot more streamlined',
      Sub2: 'than the other print-on-demand that we used and the quality is a lot better.',
      Title3: 'TeArra',
      Sub3: 'CEO & Founder'
    },
    Module5: {
      Title1: 'More Guides On Print-on-demand'
    },
    Module6: {
      Title1: 'Start Selling for Free',
      Sub1: 'Grow Your Fashion Business with KakaClo',
      StartSelling: 'Start Selling'
    }
  },
  Customize: {
    Module1: {
      Title1: 'Next Generation Fashion',
      Title2: 'Customization',
      Sub1: 'Supported by Top Clothing Manufacturers',
      Btn: 'I Need Customization'
    },
    Module2: {
      Title1: 'You’ve Got The Vision, We’ve Got The Tools',
      Sub1: 'KakaClo Studio stitches an online ecosystem of software and services that enables fashion designers and enterprises to work with real time 3D simulation, surpassing their productivity, sustainability and creativity.',
      Title2: 'Design Submit',
      Title3: 'Creating',
      Title4: '3D Simulation',
      Title5: 'Product',
      Title6: 'Shipping',
      Title7: 'What We Provide',
      Title8: 'Print on Demand',
      Sub2: 'If you want to print your own logo or design on the product, upload the logo or patterns, we will print for you.',
      Title9: 'Packaging on Demand',
      Sub3: 'Let us know if you have any special packaging requirement, we will pack in the way you want.',
      Title10: 'Customize on Demand',
      Sub4: 'Share with us your design or idea, we will make a sample for you and keep it as your private style.'
    },
    Module3: {
      Title1: 'Kaka Clothing Studio',
      Sub1: 'The meta fashion workshop(Coming soon)'
    },
    Module4: {
      Title1: 'Competitive Advantage',
      Sub1: 'Clothing with Cooperated Factories',
      Sub2: 'Trusted By Fashion Brands',
      Sub3: 'Require For Mass Products',
      Sub4: 'Offer In Class Service'
    },
    Module5: {
      Title: 'Products Suitable For Customization in KakaClo',
      Btn: 'I Need Customization',
      Title1: 'Custom Jeans Manufacturer',
      Sub1: 'Delivering premium quality customized jeans at competitive prices, we are manufacturers offering a full line of meticulously crafted denim products. Covering skinny fits, slim fits, ripped, stretch, cropped, high-rise, bell-bottom jeans, etc.',
      Title2: 'Cut And Sew Manufacturing',
      Sub2: 'As cut and sew manufacturers, we tailor your garments from raw fabric, ensuring each item in your custom clothing line is carefully crafted with attention to detail.',
      Title3: 'Leggings Manufacturer',
      Sub3: 'We provide a variety of custom leggings for fitness enthusiasts, including tailored exercise leggings, sublimation versions, and comfy capris. We prioritize customization for personalized style and comfort.',
      Title4: 'Custom Leather Goods',
      Sub4: "We're experienced leather goods manufacturers known for quality. We offer production and development services for other brands, whether it's for corporate gifts or starting a small leather brand. We've got you covered!",
      Title5: 'Hat Manufacturing',
      Sub5: 'KakaClo crafts custom headgear and hats tailored for action sports, street fashion, and diverse lifestyles. Our hats are high-quality and budget-friendly, with customization options for color, fabric, and design to meet your specific requirements.',
      Title6: 'Custom Sweatshirts',
      Sub6: "KakaClo is the go-to for custom-made sweatshirts that cater to your preferences. We're your one-stop-shop for stylish sweatshirt needs, dedicated to offering sustainable, high-quality products.",
      Title7: 'Custom Made T-Shirt',
      Sub7: "T-shirt sales are enormous, and the competition is extremely fierce, requiring innovative and personalized products to target niche markets. With KakaClo's custom T-shirt services, you have the opportunity to stand out!",
      Title8: 'Bra Manufacturer',
      Sub8: "KakaClo's custom service provides intricately designed bras for unparalleled comfort and sports support. Crafted with premium materials, our bras seamlessly blend style and function, ensuring confidence and comfort.",
      Title9: 'Custom Socks Manufacturer',
      Sub9: 'Walk with style and comfort in our custom socks. Expertly crafted by skilled manufacturers, these socks blend superior artistry with personalized designs, making every step a unique expression of individuality.',
      Title10: 'Custom Hoodie Maker',
      Sub10: 'KakaClo utilizes various custom clothing options, enabling you to create your own branded customized hoodies. Showcase high-quality, tailor-made hoodies that cater to the needs and preferences of your target markets.',
      Title11: 'Custom Sportswear Maker',
      Sub11: 'Build your custom Sportswear brand with KakaClo. Create unique Sportswear with a simple mouse click to meet the personalized requirements of your customers. We will assist you at every step, from samples to manufacturing.',
      Title12: 'Custom Made Swimsuits',
      Sub12: 'KakaClo is dedicated to providing automated customization tools for those entering the fashion industry. Streamlining the process, obtain an exclusive collection of custom swimwear from a top manufacturer specializing in traditional and intricate swimwear designs.'
    },
    Module6: {
      Title1: 'Made With Care And Made To Order',
      Sub1: 'No need for design sketches, use existing pattern modules for combined design.'
    },
    Module7: {
      Title1: 'More Guides On Customization'
    },
    Module8: {
      Title1: 'Start Selling For Free',
      Sub1: 'Grow Your Fashion Business With KakaClo',
      Btn: 'Start Selling',
      Btn1: 'Sign Up For Free'
    },
    Module9: {
      Title: 'Frequently Asked Questions',
      Title1: 'How much does it cost to manufacture clothing?',
      Sub1: "Clothing manufacturing costs vary based on factors like quantity, quality, and material value. Additional costs beyond the unit cost may or may not exist, depending on early-stage product development needs like prototypes and samples. KakaClo's customization service utilizes automation for efficiency and is here to assist at any stage. Feel free to reach out for guidance!",
      Title2: 'How can I produce clothing of my own?',
      Sub2: "If you intend to manufacture clothing for your brand, the first consideration is whether your products have sufficient demand to meet the quantity requirements set by clothing manufacturers (KakaClo's customization service has a minimum order quantity of 100).",
      Sub3: 'With KakaClo, you can easily customize various personalized garments through automated processes, without the need for specialized skills.',
      Title3: 'How long does it take for customized clothing to be produced?',
      Sub4: 'At KakaClo, the first mass production can be delivered in as fast as 14 days.',
      Title4: 'Can I customize clothing in different styles with the same design?',
      Sub5: 'Certainly, you can effortlessly incorporate your design into various styles directly within our fashion workshop.',
      Title5: 'How is the pricing for custom clothing determined?',
      Sub6: 'The all-inclusive price for your customization includes the selected product, the quantity of ink used in the design, and the total number of items in the order. Feel free to contact our staff at any time to address any questions you may have.',
      Title6: 'What material is used for custom clothing, and how do I determine the size for custom garments?',
      Sub7: 'Most clothing is made from 100% cotton, and you can also choose different materials based on your preferences. Information regarding the size of custom clothing is typically available in our size chart, and customization options are available for product fit, oversized styles, and more.'
    }
  }
}
